import { atom } from "jotai";
import {
    RouterProvider,
    createBrowserRouter,
    redirect,
} from "react-router-dom";
import PaymentMethod from "./routes/PaymentMethod";
// import OtherUploads from "./routes/OtherUploads";
import Summary from "./routes/Summary";
import ThankYou from "./routes/ThankYou";
import Fail from "./routes/SendFailed";
import { FormModel, TravelSearchModel } from "./types/FormTypes";
import Root from "./routes/root";
import Delay from "./routes/Delay";
import Intro from "./routes/Intro";
import TravelSearch from "./routes/TravelSearch";
import Compensation from "./routes/Compensation";
import CompensationForTaxi from "./routes/CompensationForTaxi";
import CompensationForCar from "./routes/CompensationForCar";
import RefundValueCode from "./routes/RefundValueCode";
import RefundBankDeposit from "./routes/RefundBankDeposit";
import RefundPreference from "./routes/RefundPreference";
import ContactDetails from "./routes/ContactDetails";
import PaymentWithTravelcard from "./routes/PaymentWithTravelcard";
import PaymentWithApp from "./routes/PaymentWithApp";
import PaymentWithBlip from "./routes/PaymentWithBlip";
import PaymentWithTicket from "./routes/PaymentWithTicket";

// import AddCertificate from "./routes/AddCertificate";
require("./extensions/yup-extensions");

/*
    Store  - Collecting Travel Search Data 
*/

export const travelSearchAtom = atom<TravelSearchModel>({
    selectedJourneyFrom: null,
    selectedJourneyTo: null,
    journeyDate: '',
    journeyTime: '',
});

/*
    Store - Collecting FormData
*/

export const formDataAtom = atom<FormModel>({
    paymentmethod: "",
    phonenumberapp: "",
    ticketnumber: "",
    cardnumber: "",
    delay: "",
    compensation: "",
    refundpreference: "",
    taxireceipt: [],
    distance: "",
    cartravelfrom: "",
    cartravelto: "",
    carlicenceplate: "",
    carexpenses: [],
    valuecodeemail: "",
    clearingnumber: "",
    accountnumber: "",
    firstname: "",
    lastname: "",
    streetaddress: "",
    zipcode: "",
    postaladdress: "",
    phonenumbercontact: "",
    emailcontact: "",
    moreinfo: "",
    journey: "",
    selectedJourney: { fromName: '', toName: '', date: '', travelTime: '', journeyKey: '', line: '', switches: '', unformattedDate: '' },
});


export const selectedJourneyAtom = atom({
    fromName: '',
    toName: '',
    date: '',
    travelTime: '',
    journeyKey: '',
    line: '',
    switches: '',
    unformattedDate: '',
});

const state = { followingForm: false };
const routerBasename = (window as any).OGT?.WebApp?.routerBasename ?? "";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            {
                index: true,
                element: <Intro />,
                loader: () => {
                    state.followingForm = true;
                    return null;
                }
            },
            {
                path: "hur-du-reste",
                element: <TravelSearch />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "hur-sen-blev-du",
                element: <Delay />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "betalningssatt",
                element: <PaymentMethod />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "med-app",
                element: <PaymentWithApp />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "med-resekort",
                element: <PaymentWithTravelcard />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "med-blipp",
                element: <PaymentWithBlip />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "med-biljett",
                element: <PaymentWithTicket />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "ersattning-for",
                element: <Compensation />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "ersattning-for-taxi",
                element: <CompensationForTaxi />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "ersattning-for-bil",
                element: <CompensationForCar />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },


            {
                path: "hur-vill-du-ha-ersattning",
                element: <RefundPreference />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "vardekod",
                element: <RefundValueCode />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "bankinsattning",
                element: <RefundBankDeposit />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                }
            },
            {
                path: "personuppgifter",
                element: <ContactDetails />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                }
            },
            {
                path: "granska-och-skicka",
                element: <Summary />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                }
            },
            {
                path: "tack-sida",
                element: <ThankYou />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "ett-fel-intraffade",
                element: <Fail />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
        ],
    },
],
    {
        basename: routerBasename
    }
);

// Count pages WIP
const pagePaths =
    router?.routes[0]?.children?.map((child) => child.path).filter(Boolean) || [];

export const pageCountAtom = atom({
    pagePaths,
});

function App() {
    // const [formData] = useAtom(formDataAtom);
    // const [medicalVisit] = useAtom(medicalVisitAtom);

    return (
        <>
            <RouterProvider router={router} />
            {/* <div className="bg-slate-900 text-white p-6 text-xs  grid-cols-2 gap-10 hidden md:grid">
        <pre>{JSON.stringify(formData, null, 2)}</pre>
        <pre>{JSON.stringify(medicalVisit, null, 2)}</pre>
      </div> */}
        </>
    );
}

export default App;
